import { fetch, post } from '../../../data/shared/api_utils';

export const fetchData = reference => fetch(`/api/reservation-followup/${reference}`);
export const fetchDataOptimalle = (reference, step) => fetch(`/api/optimalle-request/${reference}?${step}`);
export const postInstantMessage = (reference, data) => post(`/api/reservation-followup/${reference}/message`, data);
export const acceptQuotation = (reference, data) => post(`/api/reservation-followup/${reference}/accept-quotation`, data);
export const deleteDraft = (reference) => fetch(`/api/reservation-followup/${reference}/delete-draft`);
export const fetchCreditCardFields = (reference) => fetch(`/api/reservation-followup/${reference}/payment/fields`);
export const cancelAction = (reference)=> post(`/api/reservation-followup/${reference}/cancel`);
export const postQuotationUpdateCancellation = data => post('/api/reservation-request/update/cancellation', data);
